import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GiftCard } from '../models/gift-card.model';
import { CreateGiftCardPayload, UpdateGiftCardPayload } from './gift-card.service.types';

@Injectable({ providedIn: 'root' })
export class GiftCardApiService {
  private dataUrl = 'gift-cards/';

  constructor(private http: HttpClient) {}

  getOne(giftCardUuid: string) {
    return this.http.get<GiftCard>(this.dataUrl + giftCardUuid);
  }

  createOne(payload: CreateGiftCardPayload) {
    return this.http.post<GiftCard>(this.dataUrl, payload);
  }

  updateOne(giftCardUuid: string, payload: UpdateGiftCardPayload) {
    return this.http.patch<GiftCard>(this.dataUrl + giftCardUuid, payload);
  }
}
